module.exports = __webpack_public_path__ + "img/pressure.690e6537.svg";